export var SizeChangerPosition;
(function (SizeChangerPosition) {
    SizeChangerPosition["left"] = "left";
    SizeChangerPosition["right"] = "right";
})(SizeChangerPosition || (SizeChangerPosition = {}));
export var QuickJumperPosition;
(function (QuickJumperPosition) {
    QuickJumperPosition["left"] = "left";
    QuickJumperPosition["right"] = "right";
})(QuickJumperPosition || (QuickJumperPosition = {}));
